import React from 'react'
import EssentialInfos from '../../ui/essentialInfos'

type TeamEssentialsProps = {
  foundedYear: number | null
  totalEmployees: string | null
  employeeAgeAverage: number | null
  color: string | null
}

const TeamEssentials: React.FC<TeamEssentialsProps> = ({
  foundedYear,
  totalEmployees,
  employeeAgeAverage,
  color,
}) => {
  const foundedYearLabel = foundedYear ? 'Création' : null
  const totalEmployeesNumber = totalEmployees
    ? totalEmployees.replace('salariés', '')
    : null
  const totalEmployeesLabel = totalEmployees ? 'collaborateurs' : null
  const employeeAgeAverageLabel = employeeAgeAverage ? 'Âge moyen' : null

  return (
    <div>
      {color ? (
        <div
          className="container mx-auto min-h-content rounded-xl shadow-lg w-full
                flex flex-col gap-8 flex-wrap justify-center text-white p-8"
          style={{ backgroundColor: color }}
        >
          {totalEmployeesNumber && totalEmployeesLabel && (
            <EssentialInfos
              info={totalEmployeesNumber}
              label={totalEmployeesLabel}
            />
          )}
          {employeeAgeAverage && employeeAgeAverageLabel && (
            <EssentialInfos
              info={employeeAgeAverage}
              label={employeeAgeAverageLabel}
            />
          )}
          {foundedYear && foundedYearLabel && (
            <EssentialInfos info={foundedYear} label={foundedYearLabel} />
          )}
        </div>
      ) : (
        <div
          className="container mx-auto min-h-content rounded-xl shadow-lg w-full
                flex flex-col gap-8 flex-wrap justify-center bg-primary text-white p-8"
        >
          {totalEmployeesNumber && totalEmployeesLabel && (
            <EssentialInfos
              info={totalEmployeesNumber}
              label={totalEmployeesLabel}
            />
          )}
          {employeeAgeAverage && employeeAgeAverageLabel && (
            <EssentialInfos
              info={employeeAgeAverage}
              label={employeeAgeAverageLabel}
            />
          )}
          {foundedYear && foundedYearLabel && (
            <EssentialInfos info={foundedYear} label={foundedYearLabel} />
          )}
        </div>
      )}
    </div>
  )
}

export default TeamEssentials
